import { ExpandFilter } from "../../assets";
import { css } from "@emotion/react";

export interface SearchBarProps {
  search: string;
  onSearch: (search: string) => void;
  showFilters: boolean;
  onToggleFilters: () => void;
  onRefreshClick: () => void;
}

const SearchBar = ({
  search,
  onSearch,
  showFilters,
  onToggleFilters,
  onRefreshClick
}: SearchBarProps) => (
  <div
    css={css`
      display: flex;
      align-items: center;
      padding: 12px;
      border-bottom: 1px solid #282d35;
    `}
  >
    <div
      css={css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
      `}
    >
      <i className="pi pi-search" />

      <input
        css={css`
          appearance: none;
          font-family: "Poppins";
          font-size: 12px;
          width: 100%;
          padding: 4px;
          margin-left: 10px;
          border: none;
          background-color: #2f343d;
          color: #90a0b7;
        `}
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder="Buscar..."
      />
    </div>

    <div
      css={css`
        display: flex;
        align-items: center;
        gap: 14px;
        margin-left: 12px;
      `}
    >
      <div
        onClick={onToggleFilters}
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <img
          src={ExpandFilter}
          css={css`
            cursor: pointer;
            display: block;
            width: 20px;
            height: 20px;
          `}
        />
      </div>

      <i
        className="pi pi-refresh"
        css={css`
          color: #109cf1;
          cursor: pointer;
          font-size: 20px;
        `}
        onClick={onRefreshClick}
      />
    </div>
  </div>
);

export default SearchBar;
